/**
 * Destino tras SSO (`/cuenta/login/:token?returnUrl=...`).
 * Solo acepta rutas del shell `/{n}/main/...` para evitar open redirect.
 * Sustituye el índice de la URL por el de la sesión recién creada.
 */
export function resolverDestinoPostHandoff(
  indice: number,
  returnUrl: string | null | undefined
): string {
  const fallback = `/${indice}/main`;
  if (returnUrl == null || !returnUrl.trim()) {
    return fallback;
  }

  let decoded = returnUrl.trim();
  try {
    decoded = decodeURIComponent(decoded);
  } catch {
    return fallback;
  }

  const match = /^\/(\d+)\/main(\/[\w\-./]*)?$/.exec(decoded);
  if (!match) {
    return fallback;
  }

  const suffix = match[2] ?? '';
  return `/${indice}/main${suffix}`;
}
